import React, { FunctionComponent } from 'react';

import { DateTime } from 'luxon';

import { RelativeDateTime } from 'core/util/DateRange';
import { ReplyProps } from 'reviews2/feed/review-yeti/reply/ReviewReply.types';

import 'reviews2/feed/review-yeti/reply/date/ReplyDate.scss';

export const ReplyDate: FunctionComponent<ReplyProps> = ({ reply }) => {
    const dateTime = DateTime.fromISO(reply.post_created_at).toMillis();

    if (!dateTime) {
        return null;
    }

    if (!reply.properties?.permalink?.stringValues?.length) {
        return (
            <ReplyDateWrapper>
                <RelativeDateTime dateTime={dateTime} />
            </ReplyDateWrapper>
        );
    }

    return (
        <ReplyDateWrapper>
            <a
                className="perma-link"
                href={reply.properties!.permalink!.stringValues?.[0]}
                target="_blank"
                rel="noopener noreferrer"
            >
                <RelativeDateTime dateTime={dateTime} />
            </a>
        </ReplyDateWrapper>
    );
};

const ReplyDateWrapper: FunctionComponent = ({ children }) => {
    return <div className="r4e-review-reply-date">{children}</div>;
};
